import p1 from "../Resources/projects/p1.png";
import p3 from "../Resources/projects/p3.png";
import p3_1 from "../Resources/projects/p3 1.png";
import p3_2 from "../Resources/projects/p3 2.png";
import p1_2 from "../Resources/projects/p1 2.png";
import p1_3 from "../Resources/projects/p1 3.png";
import p1_4 from "../Resources/projects/p1 4.png";
import p1_5 from "../Resources/projects/p1 5.png";
import p2 from "../Resources/projects/p2.png";
import p2_2 from "../Resources/projects/p2 2.png";
import p4_1 from "../Resources/projects/p4 1.png";
import p4_2 from "../Resources/projects/p4 2.png";
import p4_3 from "../Resources/projects/p4 3.png";
import p5_1 from "../Resources/projects/p5 1.png";
import p5_2 from "../Resources/projects/p5 2.png";
import p7_1 from "../Resources/projects/p7 1.png";
import p7_2 from "../Resources/projects/p7 2.png";
import p7_3 from "../Resources/projects/p7 3.png";
import p7_4 from "../Resources/projects/p7 4.png";

const images = {
  p1,
  p1_2,
  p1_3,
  p1_4,
  p1_5,
  p2,
  p2_2,
  p3,
  p3_1,
  p3_2,
  p4_1,
  p4_2,
  p4_3,
  p5_1,
  p5_2,
  p7_1,
  p7_2,
  p7_3,
  p7_4,
};

export default images;
